import { ApiListRequest, ApiListResponse, UserStaffBean } from "@gymflow/types";
import { infiniteQueryOptions, QueryKey } from "@tanstack/react-query";

import { api } from "../../api";
import { numberPagination } from "../../numberPagination";

const keys = {
  all: () => ["staffApiHost"] as QueryKey,
  list: (filters: unknown) => [...keys.all(), "list", filters] as QueryKey,
};

export const staffApiHost = {
  keys,
  queries: {},
  infiniteQueries: {
    list: (
      params?: {
        name?: string;
        sort?: keyof UserStaffBean;
      } & Omit<ApiListRequest, "page">,
    ) =>
      infiniteQueryOptions({
        queryKey: keys.list(params),
        queryFn: async ({ pageParam }) =>
          (
            await api.get<ApiListResponse<UserStaffBean>>("/user/staff", {
              params: {
                activeUser: true,
                sort: "firstName",
                ...params,
                page: pageParam,
              },
            })
          ).data,
        ...numberPagination,
      }),
  },
  mutations: {},
};
